import React, { useEffect, useState } from "react";
import {
  createMuiTheme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import AddToListModal from "./addToListModal";
import { TOGGLE_GROWING_LIST_POPUP } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useParams } from "react-router-dom";

// const theme = createMuiTheme({
//   overrides: {
//     MuiInputLabel: {
//       outlined: {
//         transform: "translate(14px, 12.5px) scale(1)"
//       }
//     },
//     MuiOutlinedInput: {
//       root: {

//         "&&& $input": {
//           padding: "7px"
//         }
//       }
//     },
//     MuiChip: {
//       root: {
//         borderRadius: '0px',
//         height: '27px'
//       },
//       deleteIcon: {
//         color: 'black',
//         height: '15px'
//       },
//       deleteIconOutlinedColorPrimary: {
//         variant: 'outlined'
//       }
//     },
//   }
// });
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    whiteColor: {
      color: "red",
    },
    autoComplete: {
      "& .MuiTextField-root": {
        "& .MuiInputBase-root": {
          padding: "0px 0px 0px 4px",
        },
      },
    },
  })
);

function CustomSelectMulti(props) {
  // console.log(props)
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = React.useState("");
  const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({});
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = React.useState("");
  const [val, setValue] = React.useState("");

  const [options, setOptions] = React.useState([]);
  let { id } = useParams();

  const {
    // label,
    type,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    infoIcon,
    infoMessage,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    multiline,
    index,
    handleChange,
    hoverText,
    isDynamicField,
    isChild,
    dropDown,
    field_name,
    moduleName,
    itemArr,
    growingAdionalParam,
  } = props.componentObject;

  let selectOptionValues = itemArr ? itemArr.map((row) => row.id) : [];
  let selectOptionValues1 = itemArr && itemArr.map((row) => row.id);
  const handleAddNew = (event) => {
    event.preventDefault();
    setPostData({
      drop_down: dropDown,
      field_name: field_name,
      ...growingAdionalParam,
    });
    setShowModal(true);
    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: true });
  };
  useEffect(() => {
    if (field_name && dropDown) {
      setOptions([...selectOptionValues, "+Add New"]);
    }
  }, [selectOptionValues?.length]);

  const handleAddNewValue = React.useCallback(
    (newValue, id) => {
      value.push(newValue);
      isChild
        ? handleChange(value, index, "", isDynamicField)
        : handleChange(value, index);
    },
    [isChild, handleChange, value]
  );

  const filterOptions = createFilterOptions({
    stringify: (option) => option,
  });
  return (
    <FormControl size="small" variant={"outlined"} style={{ width: "100%" }}>
      <Autocomplete
        multiple
        className={classes.autoComplete}
        id="combo-box-demo"
        forcePopupIcon={true}
        disabled={disabled}
        onChange={(e, newValue) => {
          if (
            newValue.length <= 0 ||
            newValue === null ||
            newValue === undefined
          ) {
            newValue = [];
            isChild
              ? handleChange(newValue, index, "", isDynamicField)
              : handleChange(newValue, index);
          } else if (newValue.length > 0) {
            // setInputValue(newValue)
            // else {
            //   handleChange("", index)
            // }
            if (
              newValue !== null &&
              newValue !== undefined &&
              newValue.length > 0 &&
              newValue.indexOf("+Add New") !== -1
            ) {
              handleAddNew(e);
              setShowModal(true);
              const index = newValue.indexOf("+Add New");

              if (index > -1) {
                newValue.splice(index, 1);
              }
            }
            isChild
              ? handleChange(newValue, index, "", isDynamicField)
              : handleChange(newValue, index);
          }
        }}
        selectOnFocus
        handleHomeEndKeys
        getOptionSelected={(option, value) =>
          value.id ? option.id === value.id : option === value
        }
        freeSolo
        options={field_name && dropDown ? options : selectOptionValues}
        getOptionLabel={(option) => (option ? option.toString() : "")}
        value={value ? value : [] || undefined || null}
        renderInput={(params) => (
          <React.Fragment>
            <TextField
              {...params}
              required={required ? required : false}
              placeholder={placeholder}
              error={helperText ? true : false}
              variant="outlined"
              autoComplete="off"
              style={{}}
              inputProps={{
                ...params.inputProps,
                autoComplete: "off",
                form: {
                  autocomplete: "off",
                },
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    e.stopPropagation();
                  }
                },
                style: { fontSize: "16px", fontFamily: "Open Sans" },
              }}
              InputLabelProps={{
                style: { fontSize: "16px", fontFamily: "Open Sans" },
              }}
            />

            <span
              style={{
                color: "#f44336",
                fontSize: "0.75rem",
                marginRight: "14px",
              }}
            >
              {" "}
              {helperText}
            </span>
          </React.Fragment>
        )}
      />
      {showModal && (
        <AddToListModal
          setShowModal={setShowModal}
          postData={postData}
          type={moduleName}
          handleAddNewValue={handleAddNewValue}
        />
      )}
    </FormControl>
  );
}

export default CustomSelectMulti;
